import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import { VehicleCard } from "@/components/VehicleCard";

export const RecentlySoldSection = ({ content }) => {
  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/vehicles/sold", { params: { featured: true } })
      .then((r) => setVehicles(r.data.slice(0, 3)))
      .catch(() => setVehicles([]))
      .finally(() => setLoading(false));
  }, []);

  if (!loading && vehicles.length === 0) return null;

  return (
    <section className="py-16 bg-muted border-y border-border" data-testid="recently-sold-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-wrap items-end justify-between gap-4 mb-8">
          <div>
            {content.eyebrow && (
              <p className="text-xs font-mono uppercase tracking-[0.25em] text-primary mb-2">{content.eyebrow}</p>
            )}
            <h2 className="font-display text-2xl sm:text-3xl font-extrabold uppercase tracking-tight text-foreground">
              {content.heading}
            </h2>
            {content.description && (
              <p className="text-muted-foreground mt-2 max-w-xl">{content.description}</p>
            )}
          </div>
          <Link
            to="/inventory/sold"
            className="inline-flex items-center gap-2 text-sm font-bold uppercase tracking-wider text-primary hover:text-primary-hover transition-colors"
            data-testid="sold-view-all-link"
          >
            View Sold Archive <ArrowRight className="h-4 w-4" />
          </Link>
        </div>

        {loading ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {[0, 1, 2].map((i) => (
              <div key={i} className="bg-card border border-border rounded-md h-80 animate-pulse" />
            ))}
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {vehicles.map((v) => (
              <VehicleCard key={v.id} vehicle={v} sold />
            ))}
          </div>
        )}
      </div>
    </section>
  );
};
